import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, icon, description, value, change, changeType, usagePercent }) => {
  const displayChangeType = changeType || 'neutral';
  const displayUsagePercent = usagePercent !== undefined ? usagePercent : 0;

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1 hover:shadow-elevation-2 transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Icon name={icon || 'Activity'} size={20} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-muted-foreground truncate">{title}</h3>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-baseline space-x-2">
              <span className="text-2xl font-bold text-foreground">{value || '0'}</span>
              <span className={`text-sm font-medium ${
                displayChangeType === 'positive' ? 'text-success' :
                displayChangeType === 'warning' ? 'text-warning' : 'text-muted-foreground'
              }`}>
                {change || ''}
              </span>
            </div>
            {title === 'Subscription Usage' && (
              <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all duration-300 ease-out ${
                    displayUsagePercent < 50 ? 'bg-success' :
                    displayUsagePercent < 80 ? 'bg-warning' : 'bg-destructive'
                  }`}
                  style={{ width: `${Math.min(displayUsagePercent, 100)}%` }}
                />
              </div>
            )}
            <p className="text-xs text-muted-foreground">{description}</p>
            <div className="flex items-center space-x-1 mt-2">
              <div className="w-1 h-1 bg-success rounded-full"></div>
              <span className="text-xs text-success">Live data</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MetricsCard);